import React from 'react';
import './pagesStyles.css'
import HeroSlider from '../components/HeroSlider';



const About = () => {
  return (
    <HeroSlider className="here"></HeroSlider>
  );
};

export default About;